var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-2",
    "data-name": "user",
    d: "M24.859,17.14a12.647,12.647,0,0,0-3.226-2.019,1.055,1.055,0,0,0-.857,1.928,10.548,10.548,0,0,1,2.69,1.676,4.206,4.206,0,0,1,1.425,3.161v1.951a1.056,1.056,0,0,1-1.055,1.055H3.164A1.056,1.056,0,0,1,2.11,23.837V21.885a4.206,4.206,0,0,1,1.425-3.161C4.6,17.788,7.7,15.61,13.5,15.61a7.814,7.814,0,1,0-4.754-1.62,14.663,14.663,0,0,0-6.6,3.149A6.315,6.315,0,0,0,0,21.885v1.951A3.168,3.168,0,0,0,3.164,27H23.837A3.168,3.168,0,0,0,27,23.837V21.885a6.315,6.315,0,0,0-2.142-4.746ZM7.805,7.805a5.7,5.7,0,1,1,5.7,5.7A5.7,5.7,0,0,1,7.805,7.805Zm0,0",
    transform: "translate(0 0)",
    fill: "#2d335d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.60f216e66c8d508a29f6fb64c4da4dfc.svg";
export { ForwardRef as ReactComponent };